import React, { useContext } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import NotFound from '../NotFound'
import { AbilityContext } from '../../components/Ability'
import FacebookPage from './Features/Facebook'


const ChatPage = () => {
  const navigate = useNavigate()
  const ability = useContext(AbilityContext)

  return (
    <>
      <Routes>
        <Route
          path="/facebook"
          element={
            ability.can('read', 'Chat') ? <FacebookPage /> : <NotFound />
          }
        />
      </Routes>
    </>
  )
}

export default ChatPage
